import ApiBaseService from "./ApiBaseService";

const getUser = () => {
  return ApiBaseService.get(`/user`, {});
};
const loginUser = () => {
  return ApiBaseService.get(`/auth/login`, {});
};
const logoutUser = () => {
  return ApiBaseService.get(`/auth/logout`, {});
};
export { getUser, loginUser, logoutUser };
